import React from 'react';
import './Discount.scss';

const Discount = (props) => {
  if (props.rate !== 1.0) {
    return (
      <div className='discount-alert d-flex justify-content-center text-center alert' role="alert"><span><b>You are enjoying an extra {100 - props.rate * 100}% savings on tuition</b></span></div>
    );
  }
  return null;
}

export default Discount;
